import { useStore } from 'vuex'
import { computed, ref, Ref } from 'vue'
import { getStorage } from '@/utils/index'
import { TOKENKEY } from '@/config/constant'
import { isIos, isAndrod } from '@/utils/app'
import { InsuranceStoreState } from '@/store/insurance'
import { commonErrorHandle } from '@/utils/error-handle'
import { clearToast, showToastLoading } from '@/utils/tools'
import { useLocactionInfo, usePlatformInfo } from '@/compositions/common'
import { getDownloadPolicyUrl, getDeviceInsuranceInfo } from '@/apis/insurance'
import {
  ClientJijiaInsuranceDetail,
  ClientJijiaInsuranceListItem,
  DeviceJijiaInsuranceInfo,
} from '@/types/insurance'
import {
  judgeJijiaInsuranceNeedCheckQuotaReplenishment,
  judgeJijiaInsuranceDeviceCanQuotaReplenishment,
} from '@/views/insurance/common'
import appHost from '@/utils/app'

export function useCommon(): {
  downloadPolicyOrder: (policy_no: string) => void
  canQuotaReplenishment: Ref<boolean>
  checkQuotaReplenishment: (detail: ClientJijiaInsuranceDetail) => Promise<boolean>
} {
  const canQuotaReplenishment = ref(false)

  async function downloadPolicyOrder(policy_no: string) {
    showToastLoading()
    try {
      const data = await getDownloadPolicyUrl(policy_no)
      appHost.openBrowser(data.url)
      clearToast()
    } catch (error) {
      commonErrorHandle(error)
    }
  }

  async function checkQuotaReplenishment(detail: ClientJijiaInsuranceDetail) {
    if (judgeJijiaInsuranceNeedCheckQuotaReplenishment(detail)) {
      try {
        const data = await getDeviceInsuranceInfo(detail?.eq_sn)
        canQuotaReplenishment.value = judgeJijiaInsuranceDeviceCanQuotaReplenishment(data[0])
        return canQuotaReplenishment.value
      } catch (error) {
        console.log('error', error)
      }
    }
    return false
  }
  return {
    downloadPolicyOrder,
    checkQuotaReplenishment,
    canQuotaReplenishment,
  }
}
export function useInsuranceStore(): {
  addInsuranceListKeepAlive: () => void
  removeInsuranceListKeepAlive: () => void
  addInsuranceRefundKeepAlive: () => void
  removeInsuranceRefundKeepAlive: () => void
  addInsuranceFormPageKeepAlive: () => void
  removeInsuranceFormPageKeepAlive: () => void
  updatePriceDetailItemChangeKey: () => void
  insranceState: InsuranceStoreState
} {
  const $store = useStore()
  const insranceState: InsuranceStoreState = $store.state.InsranceStore

  function addInsuranceListKeepAlive() {
    $store.commit('InsranceStore/addInsuranceListKeepAlive')
  }
  function removeInsuranceListKeepAlive() {
    $store.commit('InsranceStore/removeInsuranceListKeepAlive')
  }
  function addInsuranceRefundKeepAlive() {
    $store.commit('InsranceStore/addInsuranceRefundKeepAlive')
  }
  function removeInsuranceRefundKeepAlive() {
    $store.commit('InsranceStore/removeInsuranceRefundKeepAlive')
  }
  function addInsuranceFormPageKeepAlive() {
    $store.commit('InsranceStore/addInsuranceFormPageKeepAlive')
  }
  function removeInsuranceFormPageKeepAlive() {
    $store.commit('InsranceStore/removeInsuranceFormPageKeepAlive')
  }
  function updatePriceDetailItemChangeKey() {
    $store.commit('InsranceStore/updatePriceDetailItemChangeKey')
  }
  return {
    insranceState,
    addInsuranceListKeepAlive,
    removeInsuranceListKeepAlive,
    addInsuranceRefundKeepAlive,
    removeInsuranceRefundKeepAlive,
    addInsuranceFormPageKeepAlive,
    removeInsuranceFormPageKeepAlive,
    updatePriceDetailItemChangeKey,
  }
}

export function useCustomServiceInfo(option?: { phone: string }): {
  phone: string
  callHandle: () => void
} {
  const phone = option?.phone || '400 980 3131'
  return {
    phone,
    callHandle: () => {
      appHost.postCallPhone(phone)
    },
  }
}

export function useThreeLiabilityFunction(): {
  getReceiveThreeLiabilityUrl: (option: {
    sn: string
    name: string
    deviceName: string
    from?: string
  }) => Promise<string>
} {
  const store = useStore()
  const { getUserLocationLngLat } = useLocactionInfo()
  const { isLandscape } = usePlatformInfo()
  const appStatusBarHeightOrigin = computed<number>(() =>
    isLandscape.value ? 0 : store.state.appStatusBarHeightOrigin
  )
  async function getReceiveThreeLiabilityUrl(option: {
    sn: string
    name: string
    deviceName?: string
    from?: string
  }) {
    // 生成路径参数
    const obj = {} as Record<string, string>
    try {
      const data = await getUserLocationLngLat()
      obj.lng = String(data[0] || '0')
      obj.lat = String(data[1] || '0')
    } catch (error) {
      console.log('error', error)
    }
    obj.sn = option.sn
    obj.token = getStorage(TOKENKEY) as string
    obj.name = option.name
    obj.client = isIos ? 'ios' : isAndrod ? 'android' : ''
    obj.height = appStatusBarHeightOrigin.value + ''
    obj.from = option.from || 'maualReceive' // 手动领取标识
    if (option.deviceName) {
      obj.deviceName = option.deviceName
    }
    const pramsStr = Object.keys(obj)
      .map((key) => `${key}=${obj[key]}`)
      .join('&')
    return `${process.env.VUE_APP_WEB_URL_RECEIVE_INSURANCE_URL}/?${pramsStr}`
  }
  return {
    getReceiveThreeLiabilityUrl,
  }
}
